// import Core components
import Instagram from "@/elements/Shared/SVGs/Instagram";
import Tiktok from "@/elements/Shared/SVGs/TikTok";
import parser from "html-react-parser";
import dynamic from "next/dynamic";

// import custom components
const Button = dynamic(() => import("@/elements/Shared/Button"));
const DDistrictWeb = dynamic(
  () => import("@/elements/Shared/SVGs/DDistrictWeb")
);
const LinkNav = dynamic(() => import("@/elements/LinkNav"));
const DegradeEffect = dynamic(
  () => import("@/elements/Shared/DesignComponents/DegradeEffect")
);
const FacebookSvg = dynamic(() => import("@/elements/Shared/SVGs/Facebook"));
const LinkedInSvg = dynamic(() => import("@/elements/Shared/SVGs/LinkedIn"));

// import data
import footer from "src/data/layout/footer.json";

// import styles
import styles from "./footer.module.scss";

export default function Footer() {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <footer>
      <DegradeEffect />

      <div className={`container ${styles._grid_container}`}>
        <div className={styles._slogan}>
          <p>{footer.slogan}</p>
        </div>

        <div className={styles._logo}>
          <LinkNav path="/" ariaLabel="District web page d'accueil">
            <DDistrictWeb />
          </LinkNav>
        </div>

        <ul className={styles._menu_pages}>
          {footer.pages.map((page) => {
            return (
              <li key={page.title}>
                <LinkNav
                  path={page.lien}
                  className={styles["footer-menu-items"]}
                >
                  {page.title}
                </LinkNav>
              </li>
            );
          })}
        </ul>

        <ul className={styles._menu_services}>
          {footer.services.map((service) => {
            return (
              <li key={service.title}>
                <LinkNav
                  path={service.lien}
                  className={styles["footer-menu-items"]}
                >
                  {service.title}
                </LinkNav>
              </li>
            );
          })}
        </ul>

        <div className={styles._contact}>
          <div className={styles._contact_container}>
            <Button
              className={styles["contact-btn"]}
              path="/contact"
              bg="blue"
              border={"white"}
              color=""
              icon={true}
              is3dFlip={true}
              isFrontAbosolute={true}
            >
              <>
                <span className={styles["contact-btn-overlay"]}></span>
                Contact
              </>
            </Button>

            <div className={styles._contact_social_media}>
              {footer.social_media.map((social_media) => {
                return (
                  <a
                    key={social_media.icon}
                    href={social_media.lien}
                    className={styles._social_media_link}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={social_media.alt}
                  >
                    {/* {social_media.icon === "facebook" ? (
                      <FacebookSvg />
                    ) : (
                      <LinkedInSvg />
                    )} */}
                    {social_media.icon === "facebook" ? (
                      <FacebookSvg />
                    ) : social_media.icon === "linkedin" ? (
                      <LinkedInSvg />
                    ) : social_media.icon === "tiktok" ? (
                      <Tiktok />
                    ) : (
                      <Instagram />
                    )}
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className={styles._copyright_container}>
          <div className={styles._adresse}>
            <p>{parser(footer.address)}</p>
            <a href={`tel:${footer.phone.href}`}>{footer.phone.text}</a>
          </div>

          <p className={styles._copyright}>
            <span>&#169;</span>
            {year}
            {footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}
